import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { whatsappUrl } from "../data/site";

export default function Header() {
  const { pathname } = useLocation();
  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="logo-link" data-testid="header-home-link">
          <Logo />
        </Link>
        <nav className="site-nav" aria-label="Main navigation">
          <Link
            to="/"
            className={pathname === "/" ? "nav-link active" : "nav-link"}
            data-testid="nav-home-link"
          >
            Home
          </Link>
          <Link
            to="/rooms"
            className={pathname === "/rooms" ? "nav-link active" : "nav-link"}
            data-testid="nav-rooms-link"
          >
            Rooms
          </Link>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-small"
            data-testid="book-now-header"
          >
            Book Now
          </a>
        </nav>
      </div>
    </header>
  );
}
